import { gql } from 'gql/__generated__'

export const fileObjFragment = gql(`
  fragment FileSchema on File {
    id
    metaId
    origin
    path
    ext
    size
    width
    height
    type
    key
    error
    isProcessed
    isFastStart
  }
`)

export const fileFragment = gql(`
  fragment FileMetaSchema on FileMeta {
    id
    origin
    files {
      ...FileSchema
    }
    status
    name
    type
    size
    isArchived
    isProcessed
    createdAt
    updatedAt
    usageCount
    createdBy {
      id
    }
  }
`)

export const fileMetaWithUsageFragment = gql(`
  fragment FileMetaWithUsageSchema on FileMeta {
    ...FileMetaSchema
    fileUsage {
      ...FileUsageSchema
    }
  }
`)

export const fileMetaGroupFragment = gql(`
  fragment FileMetaGroupSchema on FileMetaGroup {
    id
    name
    color
    parentId
    lvl
    isArchived
    companyId
    createdAt
    updatedAt
    createdFor
    size
  }
`)

export const filesGroupsFragment = gql(`
  fragment FilesGroups on FileMetaGroup {
    id
    name
    color
    parentId
    lvl
    isArchived
    companyId
    createdAt
    updatedAt
    createdFor
    size
    createdBy {
      id
    }
  }
`)

export const ExternalImageFragment = gql(`
  fragment ExternalImage on ExternalImage {
    id
    name
    width
    height
    urls {
      raw
    }
    user {
      name
      username
    }
  }
`)

export const UnsplashExternalImagesFragment = gql(`
  fragment UnsplashExternalImages on UnsplashExternalImages {
   total
    limit
    offset
    externalImages {
      ...ExternalImage
    }
    }
`)

export const FileUsageFragment = gql(`
  fragment FileUsageSchema on UsageBlockItem {
    blockUuid
    fileUsageId
    blockName
    isCropped
    context {
      elementId
      nodeId
      isStash
      name
      isBackground
      isBorder
      elementType
    }
    project {
      id
      name
      sectionsOrder {
        id
        lvl
      }
    }
    section {
      id
      name
      type
      blocksOrder
    }
  }
`)
